// Показывает все записи в истории
function ShowAll() {
  DoAction('showall=1', false);
  return false;
}